import "./Vegas.css";
import { withTranslation } from "react-i18next";
import { loc, search, close } from "../../../assets/images";
import { useEffect, useState, useRef } from "react";
import Datetime from "react-datetime";
import { HomeService } from "../../../services";
import { useNavigate } from "react-router";
import { alertActions } from "../../../actions";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "@mui/material";
import { MyAccountService } from "../../../services";
import { useLocation } from "react-router-dom";

const Vegas = (props) => {
  const user_id = useSelector((state) => state?.userData?.user?._id);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locationsss = useLocation();
  const locs = window.location.href;
  const { t } = props;
  const [loader, setLoader] = useState("notset");
  const [datetimevalue, setdatetimevalue] = useState("");
  const [datetimevalue1, setdatetimevalue1] = useState("");
  const [checkindate, setCheckindate] = useState();
  const [checkoutdate, setCheckoutdate] = useState();
  const [checkintime, setCheckintime] = useState("");
  const [checkouttime, setCheckouttime] = useState("");
  const [roomCountss, setRoomCountss] = useState("");
  const [adultCount, setAdultCount] = useState("");
  const [childrenCount, setChildrenCount] = useState("");
  const [removeRooms, setRemoveRooms] = useState(false);
  const [childAgeSelected, setChildAgeSelected] = useState(false);
  const [childrenAges, setChildrenAges] = useState([]);
  const [modalRenderTrigger, setModalRenderTrigger] = useState(false);
  const [showDefault, setShowDefault] = useState(true);
  const RoomCount = localStorage.getItem("RoomCount");
  const prevUserIdRef = useRef();

  useEffect(() => {
    setCheckindate("");
    setCheckoutdate("");
    setAdultCount(localStorage.getItem("AdultCount"));
    setRoomCountss(localStorage.getItem("RoomCount"));
    setChildrenCount(localStorage.getItem("ChildrenCount"));
    setChildrenAges(JSON.parse(localStorage.getItem("ChildrenAgesArray")));

    if (
      localStorage.getItem("datetime1") &&
      localStorage.getItem("datetime2")
    ) {
      setdatetimevalue(localStorage.getItem("datetime1"));
      setdatetimevalue1(localStorage.getItem("datetime2"));

      const date = new Date(localStorage.getItem("datetime1"));
      localStorage.setItem("datetimeIn", date.toISOString().split("T")[0]);

      // // When retrieving the date
      const storedDate = date;
      setCheckindate(storedDate);

      const date2 = new Date(localStorage.getItem("datetime2"));
      localStorage.setItem("datetimeOut", date2.toISOString().split("T")[0]);

      // // When retrieving the date
      const storedDate2 = date2;
      setCheckoutdate(storedDate2);

      setCheckindate(
        new Date(localStorage.getItem("datetime1")).toISOString().split("T")[0]
      );
      setCheckoutdate(
        new Date(localStorage.getItem("datetime2")).toISOString().split("T")[0]
      );
    }

    // localStorage.setItem("datetime2", "");
    // localStorage.setItem("datetime1", "");
  }, []);

  useEffect(() => {
    if (locationsss.pathname === "/Login") {
      // Reset all the states when navigating to '/Login'
      setAdultCount("");
      setRoomCountss("");
      setChildrenCount("");
      setChildrenAges("");
      setCheckindate("");
      setCheckoutdate("");
      localStorage.removeItem("ChildrenCount");
      localStorage.removeItem("ChildrenAgesArray");
      localStorage.removeItem("ChildrenAges");
      localStorage.removeItem("RoomCount");
      localStorage.removeItem("AdultCount");
      localStorage.removeItem("datetime1");
      localStorage.removeItem("datetime2");
    }
  }, [locationsss]);

  // useEffect(()=>{
  //   setAdultCount(localStorage.getItem("AdultCount"));
  //   setRoomCountss(localStorage.getItem("RoomCount"));
  //   setChildrenCount(localStorage.getItem("ChildrenCount"));
  //   setChildrenAges(JSON.parse(localStorage.getItem("ChildrenAgesArray")));
  // },[adultCount,roomCountss,childrenCount,childrenAges])

  const handleChangess = (event) => {
    setRemoveRooms(true);
    localStorage.setItem("RoomCount", event.target.value);
    setRoomCountss(event.target.value);
    setShowDefault(false);
    setAdultCount("");
    setChildrenCount("");
  };

  const handleClickss = () => {
    if (user_id) {
      console.log("fgjksfdghhfd");
      setShowDefault(false);
    } else {
      navigate(`/Login`);
      alertActions.error(t("Please Login to continue"));
    }
  };

  const handleClick = () => {
    setRemoveRooms(true);
  };

  const handleAdultChangess = (event) => {
    localStorage.setItem("AdultCount", event.target.value);
    setAdultCount(event.target.value);
  };

  const handleChildrenChangess = (event) => {
    setChildrenAges([]);
    setChildAgeSelected(false);
    localStorage.setItem("ChildrenCount", event.target.value);
    localStorage.removeItem("ChildrenAgesArray");
    setChildrenCount(event.target.value);
    setModalRenderTrigger((prev) => !prev);
  };

  const handleChildAgeChange = (index, event) => {
    // setChildrenAges([])
    setChildAgeSelected(false);
    const newAges = [...childrenAges];
    newAges[index] = parseInt(event.target.value, 10);
    localStorage.setItem("ChildrenAges", newAges);
    localStorage.setItem("ChildrenAgesArray", JSON.stringify(newAges));
    setChildrenAges(newAges);

    console.log("Updated Children Ages:", newAges);
  };

  // onChange={(e) => setChildrenCount(e.target.value) }

  /**
   * store value in local storage and replace the format of time to 12:00:00 format
   * @param {*} e
   */
  const onChangeValue = (e) => {
    if (user_id) {
      localStorage.setItem("datetime1", e);
      setdatetimevalue(
        localStorage.getItem("datetime1")
          ? localStorage
              .getItem("datetime1")
              .replace("00:00:00 GMT+0530", "14:00:00 GMT+0530")
          : new Date()
      );
      const originalDate = new Date(localStorage.getItem("datetime1"));
      originalDate.setDate(originalDate.getDate() + 1);
      const updatedDateStr = originalDate.toISOString();
      setdatetimevalue1(updatedDateStr);
      localStorage.setItem(
        "datetime2",
        originalDate.toString().split("(")[0].trim()
      );
      convert(e);
      convertCheckout(updatedDateStr);
      setRoomCountss("");
      setAdultCount("");
      setChildrenCount("");
      setChildrenAges([]);
      localStorage.removeItem("datetimeIn");
      localStorage.removeItem("datetimeOut");
    } else {
      navigate(`/Login`);
      alertActions.error(t("Please Login to continue"));
    }
  };

  /**
   * convert given date and time to a format
   * @param {*} str
   */
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2),
      hours = 12,
      minutes = ("0" + date.getMinutes()).slice(-2);
    setCheckindate([date.getFullYear(), mnth, day].join("-"));
    setCheckintime([hours, minutes].join(":"));
  }

  const closeModal = () => {
    setRemoveRooms(false);
  };

  /**
   * search date will call only when entering both checkin and checkout date
   */
  const searchDate = () => {
    const actualValues = Array.isArray(childrenAges)
      ? childrenAges.filter((item) => item !== undefined)
      : [];

    // const actualValues = childrenAges?.filter((item) => item !== undefined);
    // console.log(
    //   childrenAges,
    //   actualValues.length,
    //   childrenCount,
    //   checkindate,
    //   checkoutdate,
    //   "fkjsadgfkhsfg"
    // );
    // if (actualValues.length == childrenCount) {
    setRemoveRooms(false);
    setChildAgeSelected(false);
    if (checkindate && checkoutdate) {
      if (localStorage.getItem("datetime1") !== null) {
        localStorage.setItem("datetimes", localStorage.getItem("datetime1"));
      }
      if (localStorage.getItem("datetime2") !== null) {
        localStorage.setItem("datetimes1", localStorage.getItem("datetime2"));
      }
      navigate(`/`, {
        state: { checkindate: checkindate, checkoutdate: checkoutdate },
      });
    }
    // }
    // else {
    //   setRemoveRooms(true);
    //   setChildAgeSelected(true);
    //   dispatch(alertActions.error("Please select Children Age"));
    // }
  };

  /**
   * convert checkout date to the format which api needs
   * @param {*} str
   */
  function convertCheckout(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2),
      hours = 23,
      minutes = ("0" + date.getMinutes()).slice(-2);
    // var ampm = hours >= 12 ? 'PM' : 'AM';
    setCheckoutdate([date.getFullYear(), mnth, day].join("-"));
    setCheckouttime([hours, minutes].join(":"));
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  /**
   * on change of checkout date setting it to local storage and other functionalities
   * @param {*} e
   */
  const onChangeValue1 = (e) => {
    if (user_id) {
      const updatedDate = formatDate(e);
      localStorage.setItem("datetime2", updatedDate);
      // setdatetimevalue1(
      //   localStorage.getItem("datetime2")
      //     ? localStorage
      //         .getItem("datetime2")
      //         .replace("00:00:00 GMT+0530", "12:00:00 GMT+0530")
      //     : ""
      // );
      if (e) {
        setdatetimevalue1(e.toString()); // Update state with the selected date
        localStorage.setItem("datetime2", e.toString()); // Update localStorage
      }
      convertCheckout(e);
      setRoomCountss("");
      setAdultCount("");
      setChildrenCount("");
      setChildrenAges([]);
      localStorage.removeItem("datetimeIn");
      localStorage.removeItem("datetimeOut");
    } else {
      navigate(`/Login`);
      alertActions.error(t("Please Login to continue"));
    }
  };

  /**
   * render the screen
   */
  const renderMainScreen = () => {
    return (
      <div className="international flt">
        {/* <div className="airport">
          <div className="hotel flt mb-2">{t("White_Lotus")}</div>
          <img src={loc} alt="no_image" />{" "}
          {t("Maruthi Veethika Rd, Thenkpete, Udupi Karnataka 576101")}
        </div> */}
        {locs.split("/")[3] === "" && (
          <div className="right_date">
            <Datetime
              name="checkin"
              dateFormat="DD/MM/YYYY"
              onChange={onChangeValue}
              value={new Date(datetimevalue)}
              closeOnSelect={true}
              timeFormat={null}
              isValidDate={(currentDate, selectedDate) =>
                currentDate.isAfter(new Date().getTime() - 24 * 60 * 60 * 1000)
              }
              inputProps={{
                placeholder: "Check-In",
                disabled: false,
                readOnly: true,
                onKeyDown: (e) => e.preventDefault(),
              }}
            />

            <Datetime
              dateFormat="DD/MM/YYYY"
              name="checkout"
              timeFormat={null}
              onChange={onChangeValue1}
              value={new Date(datetimevalue1)}
              closeOnSelect={true}
              isValidDate={(currentDate) => {
                const checkinDate = new Date(datetimevalue);
                return (
                  currentDate.isAfter(checkinDate) &&
                  currentDate.isAfter(
                    new Date().getTime() - 24 * 60 * 60 * 1000
                  )
                );
              }}
              inputProps={{
                placeholder: "Check-Out",
                disabled: false,
                readOnly: true,
                onKeyDown: (e) => e.preventDefault(),
              }}
            />

            <div className="room_count_divs">
              {/* <div>Room Count</div> */}
              <select
                className="for"
                value={roomCountss}
                onMouseDown={handleClickss}
                onChange={handleChangess}
              >
                {showDefault && (
                  <option value="" disabled>
                    Rooms & Guests
                  </option>
                )}
                <option value="">Rooms</option>
                {[...Array(25)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </select>
            </div>

            {roomCountss && adultCount && (
              <div
                className="room_count_divs selectedCount"
                onClick={handleClick}
              >
                {roomCountss} Rooms, {adultCount} Adults
              </div>
            )}
            {/* <div className="room_count_divs">
              <select
                className="for"
                value={adultCount ? adultCount : roomCountss}
                onChange={handleAdultChangess}
              >
                <option value="" disabled>
                  Adult Count
                </option>
                {[...Array(20)].map((_, index) => (
                  <option
                    key={index + 1}
                    value={index + 1}
                    disabled={index + 1 < roomCountss}
                  >
                    {index + 1}
                  </option>
                ))}
              </select>
            </div>
            <div className="room_count_divs">
              <select
                className="for"
                value={childrenCount}
                onChange={handleChildrenChangess}
              >
                <option value="" disabled>
                  Children Count
                </option>
                {[...Array(6)].map((_, index) => (
                  <option key={index} value={index}>
                    {index}
                  </option>
                ))}
              </select>
            </div> */}

            <div
              className={
                !checkindate || !checkoutdate || !roomCountss || !adultCount
                  ? "noevents"
                  : ""
              }
            >
              <button onClick={searchDate}>
                <img src={search} alt="no_image" />
              </button>
            </div>
          </div>
        )}
        <Modal
          open={removeRooms}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="modal_container"
        >
          {/* {renderTrigger && <></>} */}
          <div
            className="view_details_popup  gsdgsdfg"
            key={modalRenderTrigger}
          >
            <div className="view_details_header">
              {/* <p className="heading">Select who will stay in Room</p> */}

              <div className="options">
                {/* <div className="option" onClick={addMoreRooms}>
               <img src={add_shopping_cart2} />
               <p className="addMoreRoom">Add More Rooms</p>
             </div> */}
                <img src={close} onClick={closeModal} />
                {/* <img onClick={closeModal} /> */}
              </div>
            </div>
            <div>
              <div className=" modal_ppp guest_adults flt">
                <div className="main_adult_img home_count person_count">
                  Rooms
                </div>
                <div className="main_increment">
                  <select
                    className="for"
                    value={roomCountss}
                    onMouseDown={handleClickss}
                    onChange={handleChangess}
                  >
                    {showDefault && (
                      <option value="" disabled>
                        Room/Guest Count
                      </option>
                    )}
                    <option value="" disabled>
                      Rooms Count
                    </option>
                    {[...Array(25)].map((_, index) => (
                      <option key={index + 1} value={index + 1}>
                        {index + 1}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className=" modal_ppp guest_adults flt">
                <div className="main_adult_img home_count person_count">
                  Adults
                </div>
                <div className="main_increment">
                  {" "}
                  <select
                    className="for"
                    value={adultCount}
                    onChange={handleAdultChangess}
                  >
                    <option value="" disabled>
                      Adults
                    </option>
                    {[...Array(RoomCount * 2)].map((_, index) => (
                      <option
                        key={index + 1}
                        value={index + 1}
                        disabled={index + 1 < roomCountss}
                      >
                        {index + 1}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div>
              <button
                onClick={searchDate}
                className={
                  !checkindate || !checkoutdate || !roomCountss || !adultCount
                    ? "noevents select_room searchBtns"
                    : " select_room searchBtns"
                }
              >
                Search
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  };
  return <div className=" flt">{renderMainScreen()}</div>;
};

export default withTranslation()(Vegas);
